import React from "react";

export const roleLabels = {
  admin: "المشرف العام",
  supervisor: "مشرف",
  pending_supervisor: "مشرف (بانتظار الموافقة)",
  teacher: "مدرس / محاضر",
  student: "طالب",
};

export const statusBadge = {
  active: { label: "نشط", cls: "bg-emerald-100 text-emerald-800" },
  upcoming: { label: "قادم", cls: "bg-blue-100 text-blue-800" },
  finished: { label: "منتهي", cls: "bg-slate-200 text-slate-700" },
  approved: { label: "مقبول", cls: "bg-emerald-100 text-emerald-800" },
  pending: { label: "قيد المراجعة", cls: "bg-amber-100 text-amber-800" },
  rejected: { label: "مرفوض", cls: "bg-red-100 text-red-700" },
  waitlist: { label: "قائمة الانتظار", cls: "bg-purple-100 text-purple-800" },
  submitted: { label: "تم التسليم", cls: "bg-blue-100 text-blue-800" },
  graded: { label: "تم التقييم", cls: "bg-emerald-100 text-emerald-800" },
};

export function StatusBadge({ status }) {
  const s = statusBadge[status] || { label: status, cls: "bg-slate-100 text-slate-700" };
  return (
    <span data-testid={`status-${status}`} className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${s.cls}`}>
      {s.label}
    </span>
  );
}

export const categoryLabel = { male: "ذكور", female: "إناث", both: "ذكور وإناث" };
